// Continuous rotating ethos wheel: Education • Infrastructure • Development
export const SpinningWheel = ({ size = 320 }) => {
  const id = "ethos-path";
  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
      data-testid="ethos-spinning-wheel"
    >
      <svg
        viewBox="0 0 200 200"
        width={size}
        height={size}
        className="animate-spin-slow"
      >
        <defs>
          <path
            id={id}
            d="M 100,100 m -78,0 a 78,78 0 1,1 156,0 a 78,78 0 1,1 -156,0"
          />
        </defs>
        <text
          fill="#111111"
          className="font-heading"
          style={{ fontSize: "11px", letterSpacing: "2px", textTransform: "uppercase", fontWeight: 600 }}
        >
          {/* Words centered within each equal third */}
          <textPath href={`#${id}`} startOffset="16.667%" textAnchor="middle">
            Education
          </textPath>
          <textPath href={`#${id}`} startOffset="50%" textAnchor="middle">
            Infrastructure
          </textPath>
          <textPath href={`#${id}`} startOffset="83.333%" textAnchor="middle">
            Development
          </textPath>
        </text>
        <text fill="#777777" style={{ fontSize: "13px", fontWeight: 700 }}>
          <textPath href={`#${id}`} startOffset="0%" textAnchor="middle">•</textPath>
          <textPath href={`#${id}`} startOffset="33.333%" textAnchor="middle">•</textPath>
          <textPath href={`#${id}`} startOffset="66.667%" textAnchor="middle">•</textPath>
        </text>
      </svg>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center">
          <div className="font-heading text-5xl font-bold tracking-tighter text-[#111111] leading-none">ZN</div>
          <div className="mt-2 font-heading text-[10px] uppercase tracking-[0.3em] text-[#777777]">for a better world</div>
        </div>
      </div>
    </div>
  );
};
